exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "form[data-v-5de2dc88]{max-width:400px}.el-form-item.is-required .el-form-item__label[data-v-5de2dc88]:before{display:none}", "", {"version":3,"sources":["/Users/danialkraven/Vue/saifi-web-user-vue-01/src/components/Reset.vue"],"names":[],"mappings":"AACA,sBACE,eAAiB,CAClB,AACD,uEACE,YAAc,CACf","file":"Reset.vue","sourcesContent":["\nform[data-v-5de2dc88] {\n  max-width: 400px;\n}\n.el-form-item.is-required .el-form-item__label[data-v-5de2dc88]:before {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5de2dc88","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Reset.vue
// module id = 1078
// module chunks = 3